import { loadingEnd, loadingStart } from "./root.actions";
import { clearCNYShipToAddressAction } from "./cnyShipToAddress.actions";

/* 
1> Update store with user action data (Sync)
2> Update the backend with user action data (Async)
3> Get the latest cart data on page load. (Async)

*/
export const cartActionTypes = {
  FETCH_CART_DATA_SUCCESS: "FETCH_CART_DATA_SUCCESS",
  FETCH_CART_DATA_FAILURE: "FETCH_CART_DATA_FAILURE",
};

const fetchCartDataSuccessAction = (data) => {
  return {
    type: cartActionTypes.FETCH_CART_DATA_SUCCESS,
    data,
  };
};

// UPDATE CART REDUCER QUANTITY WITH INPUT VALUE
export const updateCartInputDataAction =
  (productInfo, value) => (dispatch, getState) => {
    dispatch(loadingStart());
    const latestState = getState();
    
    // Check if there are CNY products in cart and we're adding a normal product
    const hasCNYProducts = latestState.cart.items.some(item => item?.isCNYSuggestedOrder === true);
    
    if (hasCNYProducts && productInfo && !productInfo.isCNYSuggestedOrder) {
      // Clear CNY products from cart when adding normal products
      latestState.cart.items = latestState.cart.items.filter(item => item?.isCNYSuggestedOrder !== true);
      
      // Clear CNY ship-to address
      dispatch(clearCNYShipToAddressAction());
    }
    
    // TODO: Update productID to id in entire action
    const cartItem = latestState.cart.items.find(
      (item) => item.id === productInfo.id
    );
    
    if(productInfo && !productInfo.isCNYSuggestedOrder) {
      productInfo.isCNYSuggestedOrder = false;
      productInfo.isNormalProduct = true;
    }
    if (!cartItem) {
      if (value > 0) {
        // value = 0 ? parseInt(value) : value;
        productInfo.count = parseInt(value);
        latestState.cart.items.push(productInfo);
      }
    } else {
      (value === '' || value < 0) ? value = 0 : value;
      productInfo.count = value;
      // latestState.cart.items.push(productInfo);
      cartItem.count = value;
    }
    dispatch(fetchCartDataSuccessAction(latestState.cart.items));
    dispatch(loadingEnd());
  };

// MOVE INITIAL CART ITEMS TO CART ACTION TO UPDATE THE EXISTING PRODUCTS IF NEEDED
export const moveCartItemsToCartAction =
  (orderTypeCart) => (dispatch, getState) => {
    const latestState = getState();
    const cartItemsCopy = latestState.cartItems.items;

    let cartArray = [];
    if (orderTypeCart !== "ZYCO") {
      cartItemsCopy &&
        cartItemsCopy.map((cartItem) => {
          cartArray.push(cartItem);
          return cartArray;
        });
    }
    dispatch(fetchCartDataSuccessAction(cartArray));
  };